import styled from "styled-components";


export const Container = styled.div`
.header{
    height:450px;
    width:100%;
    overflow:hidden;
    position:relative;
    background-size:cover;
    background-position:center;
    .glassmorphic{
        background-color:rgba(0,0,0,0.5);
        width:100%;
        height:100%;

    }
}
.bg-grey{
  background-color:#d2d2d2;
}
.big-title{
    font-size:4.5rem;
}
.mid-title{
font-size:18px;
}
.bordered-card{
    background:#fff;
    border-left: 4px solid #F0553F;
    box-shadow: 0 4px 12px -4px rgb(46 55 77 / 12%);
    border-radius:5px;
    padding: 14px 24px;
    
.bordered-card-title{
   font-weight:700;  
   font-size:1.25rem;   

    color:#1478dd;

}
.bordered-card-description{
    font-size: 14px;
a{
    color:blue !important;
    font-size: 14px !important;
    text-decoration:underline !important;
}
}
}

.opportunity-container{
    .fs-none{
        flex-shrink: 0 
    }
    .search-input{
        font-size: 30px;
        font-weight: 900;
        border:none;
        outline:none;
        position:relative;
    }
    .search-input::placeholder {
        color: #1478dd;
    }
    .search-input:focus::placeholder {
        color:#d2d2d2;
    }

    .opportunity-filter-list{
        overflow-x:scroll;
        padding-bottom:20px;
        .no-wrap{
            white-space:nowrap;
        }
    }

    .opportunity-categories{
    .categories-title{
        font-size: 22px !important;
     }
     
    .opportunity-categories-list{
        display:grid;
        grid-template-columns:repeat(2,1fr);
        grid-gap:15px;
       }
     .opportunity-categories-item{
        border: 1px solid #eeedf2;
        border-radius: 2px;
        height:54px;
        background-color:#f8f7fa;

        .opportunity-categories-item-left{
         flex-grow:.2;
         background-color:#fff4f2;
         svg{
            transform:translate(0,50%);
         }
        }
        .opportunity-categories-item-right{
            flex-grow:1;
            background-color:#f8f7fa;
            p{
            transform:translate(0,50%);
            }
           }
     }
    }

    .location-based-opportunity{
        .location-based-opportunity-title{
        font-size: 22px !important;
        }
    }
}




@media (max-width:600px){
    .big-title{
        font-size:2.3rem;
    }
    .header{
        height:400px;
    }
    .mid-title{
        font-size:15px;
        }
}

@media (min-width:768px){
.opportunity-categories-list{
    display:grid;
    grid-template-columns:repeat(4,1fr) !important;
    grid-gap:15px;
   }
   .position-md-absolute{
    position:absolute;
   }
}
@media(min-width:920px){
    .position-lg-absolute{
      position:absolute;
    }
  }
`;

export const OpportunitiesWrapper = styled.div`
margin-top:60px;
.fs-35{
    font-size: 35px !important;
}
.fs-16{
    font-size: 16px;
}

.opportunities-container{
    .grid-container{
        display:grid;
        grid-template-columns:repeat(1,1fr);
        .opportunity-card{
            border:1px solid #d2d2d2;
            box-shadow: 0 16px 64px -16px rgb(46 55 77 / 10%);
        
        :hover{
           box-shadow: 0 16px 64px -16px rgb(46 55 77 / 24%);
        }
        }
 
    }
}
.opportunity-details{
    .underlined{
     text-decoration:underline !important;
    }
.opportunity-image-wrapper{
    height:500px;
}

@media (min-width:768px){
    .w-md-48{
        width:48% !important;
    }
}
@media(min-width:920px){
    .w-lg-75{
        width:75% !important;
    }
}
}

`;